import * as React from "react";
import {useContext} from "react";
import { redirect } from "react-router-dom";
import {DispatchContext} from "App";
import {useApptekster} from "../contexts/ApptekstContext";
import {SVVButton} from "@komponentkassen/svv-button";

function Utlogget() {
    const t = useApptekster();
    const dispatch = useContext(DispatchContext);

    function gaaTilInnlogging() {
        redirect(window.location.pathname);
        dispatch({type: "VIS_INNLOGGING"});
    }

    return (
        <div>
            <p>{t("vadis-kontrollrapport-utlopt-sesjon.beskjed")}</p>
            <SVVButton onClick={gaaTilInnlogging}>{t("vadis-kontrollrapport-utlopt-sesjon.innlogging-knapp")}</SVVButton>
        </div>
    )
}

export default Utlogget;
